var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalised(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 60 60",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#314e55",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.4581272 25.9511894c1.2745829 4.6650588 5.0646115 8.0488106 9.5418728 8.0488106s8.2672899-3.3837518 9.5418728-8.0488106c1.3982-.2550677 2.4581272-1.4793489 2.4581272-2.9511894 0-1.3861595-.940115-2.5527435-2.2175263-2.8969332-.9588383-5.2007827-4.9743833-9.1030668-9.7824737-9.1030668s-8.8236354 3.9022841-9.7824737 9.1030668c-1.2774113.3441897-2.2175263 1.5107737-2.2175263 2.8969332 0 1.4718405 1.0599272 2.6961217 2.4581272 2.9511894z",
    fill: "#5ecb66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56 28h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 0v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 50v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 28h-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m39 45c0-6.0751322-4.9248678-11-11-11s-11 4.9248678-11 11z",
    fill: "#5ecb66",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalised);
export default __webpack_public_path__ + "static/media/personalised.c7500705a8579a58bc18ed7105be8985.svg";
export { ForwardRef as ReactComponent };